import { GetTierResponse } from "@/src/services/types";

export const mockGetTierResponse: GetTierResponse = {
  tierList: [
    {
      name: "Smiles",
      active: "Y",
      startDate: "01/12/2019 00:00:00",
      endDate: "03/31/2050 00:00:00",
      memberName: "",
      miles: "13000",
    },
    {
      name: "Essencial",
      active: "N",
      startDate: "01/26/2024 00:00:00",
      endDate: "",
      memberName: "O VALE DO SILÊNCIO SA",
      miles: "0",
    },
    {
      name: "VoeBiz",
      active: "N",
      startDate: "01/18/2024 00:00:00",
      endDate: "01/25/2024 23:59:59",
      memberName: "O VALE DO SILÊNCIO SA",
      miles: "0",
    },
  ],
  userInfo: {
    memberNumber: "183579723",
    memberSince: "01/18/2024 12:03:12",
    miles: "0",
    dateUpgradeLimit: "01/28/2024",
    tierDateInfo: "Acumule milhas qualificáveis e conquiste a categoria Essencial",
    showUpgrade: true,
    upgradeInfo: {
      nextTier: "Prime",
      milesUpgrade: "70000",
      milesMaintenance: "1",
      totalMilesClub: "",
    },
  },
  tips: {
    cardList: [
      {
        title: "Voe GOL",
        description:
          "Trechos comprados ou resgatados com milhas na Smiles para voar GOL acumulam trechos qualificáveis que te ajudam a subir de categoria.",
        actionTarget: "buscar-voos",
      },
    ],
  },
};
